<template>
  <common-dialog ref="dialog" width="700px" title="修改库存" :data="data" :save-func="saveFunc" show-save-button
    @closed="onClosed" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="批量填充sku库存" label-width="118px">
        <el-input-number v-model="data.stockNum" :controls="false" style="width: 100px;" />
        <el-button type="primary" style="margin-left: 10px;" @click="setStock">填充</el-button>
      </el-form-item>
      <el-table :data="skuList" border style="margin-bottom: 20px;" :max-height="500">
        <el-table-column prop="spec" label="SKU 名称" show-overflow-tooltip />
        <el-table-column label="SKU 库存" width="160px">
          <template slot-scope="{row}">
            <el-input-number v-model="row._newQuantity" :controls="false" style="width: 100%;" class="input-l" />
          </template>
        </el-table-column>
      </el-table>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from '@/components/common/dialog';
import goodsApi from '@/api/pdd/goods';

export default {
  components: { commonDialog },
  data() {
    return {
      data: { stockNum: null },
      skuList: [],
    }
  },
  methods: {
    openEdit(row) {
      var sku_list = row.skuList || [];
      this.skuList = sku_list.map(function (x) {
        return {
          ...x,
          _goodsId: row.goodsId,
          _newQuantity: x.sku_quantity,
          spec: (x.spec || []).map(function (s) { return s.spec_name }).join(''),
        };
      });
      this.$refs.dialog.openEdit({ ...this.data });
    },
    setStock() {
      var self = this;
      this.skuList.forEach(function (x) { x._newQuantity = self.data.stockNum; });
    },
    saveFunc() {
      return new Promise((resolve, reject) => {
        var saveData = {
          skuList: this.skuList.map(function (x) {
            return {
              goodsId: x._goodsId,
              skuId: x.sku_id,
              quantity: x._newQuantity,
              updateType: 1,
            };
          })
        };
        goodsApi.stock(saveData).then(res => {
          if (res.data && res.data.length > 0) {
            var html = '';
            res.data.forEach(function (x) { html += '<div>' + x.title + '：' + x.errorMsg + '</div>' });
            this.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
            reject({});
          } else {
            resolve({ Code: 0 });
          }
        }).catch(err => reject(err));
      });
    },
    onClosed() {

      this.skuList = [];
    },
  }
}
</script>
